import { render, staticRenderFns } from "./ViewPrices.vue?vue&type=template&id=63f08c90&"
import script from "./ViewPrices.vue?vue&type=script&lang=js&"
export * from "./ViewPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports